module.exports = __webpack_public_path__ + "static/media/btn4.d08b61bf.svg";